/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     免登录白名单
  +--------------------------------------------------------------------------------------
*/

const whiteList = [
  '/login',
  '/pwd',
  '/refresh',
  '/403',
]

export default whiteList
